/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PredictionPickBody
 */
export interface PredictionPickBody {
    /**
     * The ID of the outcome being picked
     * @type {string}
     * @memberof PredictionPickBody
     */
    outcomeId: string;
}

/**
 * Check if a given object implements the PredictionPickBody interface.
 */
export function instanceOfPredictionPickBody(value: object): value is PredictionPickBody {
    if (!('outcomeId' in value) || value['outcomeId'] === undefined) return false;
    return true;
}

export function PredictionPickBodyFromJSON(json: any): PredictionPickBody {
    return PredictionPickBodyFromJSONTyped(json, false);
}

export function PredictionPickBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PredictionPickBody {
    if (json == null) {
        return json;
    }
    return {
        
        'outcomeId': json['outcomeId'],
    };
}

export function PredictionPickBodyToJSON(json: any): PredictionPickBody {
    return PredictionPickBodyToJSONTyped(json, false);
}

export function PredictionPickBodyToJSONTyped(value?: PredictionPickBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outcomeId': value['outcomeId'],
    };
}

